import { useSelector } from 'react-redux'
import {
    selectUserAuthCheck,
    userCentresCountSelector
} from '../../../../redux/userSlice'
import { useNavigate } from 'react-router-dom'
import { TabNames } from '../../../../routers/type'
import { useEffect } from 'react'

export const useCentreCheck = () => {
    const authed = useSelector(selectUserAuthCheck)
    const centresCount = useSelector(userCentresCountSelector)
    const navigate = useNavigate()

    const loading = authed === undefined || centresCount === undefined
    const shouldRedirectToOnboarding = !authed || centresCount === 0

    useEffect(() => {
        if(loading || !shouldRedirectToOnboarding) return
        navigate(`/${TabNames.ON_BOARDING}`, {replace: true})
    }, [navigate, loading, shouldRedirectToOnboarding])
}
